import initGTM from './vendor/initGTM';

export const loadGoogleTagManager = () => {
  const gtmTrackingID = 'GTM-TZT8737';
  initGTM(gtmTrackingID);
};
